import React, { useState, useEffect } from "react";
import { Form, Select, Typography } from "antd";
import { useTranslation } from "react-i18next";
import EmptyDamageClassForm from "../Surveys/EmptyDamageClassForm";
import InfrastructureDamageForm from "../Transport/TransportInfrastructureDamageForm";
import GoodsDamageForm from "../Network/GoodsDamageForm";
import PeopleDamageForm from "../Surveys/PeopleDamageForm";
import VehicleDamageForm from "../Network/VehicleDamageForm";
import axios from "axios";

const { Option } = Select;
const { Title } = Typography;

const TransportComponentDamageForm = props => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;
  const [damageClass, setDamageClass] = useState();
  const [damageClasses, setDamageClasses] = useState([]);

  const components = {
    'empty': EmptyDamageClassForm,
    'infrastructure': InfrastructureDamageForm,
    'vehicles': VehicleDamageForm,
    'people': PeopleDamageForm,
    'goods': GoodsDamageForm,
  };

  const handleChange = (value) => {
    if (!isEditMode) return;
    setDamageClass(value);
  };

  const getComponents = () => {
    if (damageClass) {
      const name = damageClass.toLowerCase();
      const DetailsComponent = components[name] || EmptyDamageClassForm;
      return <DetailsComponent record={props.record} parentCallback={props.parentCallback} damageClass={props.record.damage.damageClass || damageClass} isEditMode={isEditMode} />
    }
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/transport/enums/damage-classes")
      .then(({ data }) => {
        setDamageClasses(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        damageClass: props.record.damage.damageClass,
      });
      setDamageClass(props.record.damage.damageClass);
    }
  }, [props.record.damage, form]);

  return (
    <Form
      form={form}
      layout="horizontal"
      name="transportDamageForm"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      className="details_form"
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Network Component"
      />
      <Form.Item
        label="Damage class"
        name="damageClass"
        tooltip="Damage class"
      >
        <Select onChange={handleChange} disabled={!isEditMode}>
          {damageClasses.map(name => (
            <Option key={name} value={name}>
              {t('damageEnums.damageClass.' + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
      {getComponents()}
    </Form>
  );
};

export default TransportComponentDamageForm;
